import React, { useState, useEffect, useRef } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import moment from 'moment';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../components/mensajes';
import { validaSoloNumero } from '../../util/varios';
import CartasAlmacen from './cartas/cartas';
import CatalogoUbicacion from '../../catalogos/catalogoubicacion';

const TablaAlmacen = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtCodUbicacion = useRef();
  const txtDescripcion = useRef();
  const txtVentas = useRef();
  const cmbAlmacen= useRef();

  const [body, setBody] = useState(null);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [catalogoUbicacion, setCatalogoUbicacion] = useState(false);
  const [almacen, setAlmacen] = useState([]);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true
  });

  const onChange = (e) => {

    if (e.target.name === 'descripcionubicacion') {
      e.target.value = e.target.value.toUpperCase();
    }else{
      e.target.value = e.target.value;
    }
  }

  const seleccionarRegistros = () => {

    let campos = 'idalmacen, trim(descripcion) as descripcion, trim(responsable) as responsable';
    let nomtab = 'almacen';
    let orden = 'idalmacen';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {
          setAlmacen(response.data);
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const seleccionarRegistro = () => {
    let campos = 'idubicacion, trim(descripcionubicacion) as descripcionubicacion, idalmacen, ventas';
    let nomtab = 'ubicacion';
    let nomid = 'idubicacion';
    let id = txtCodUbicacion.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        txtDescripcion.current.value = '';

        if (response.data !== '') {

          txtDescripcion.current.value = response.data.descripcionubicacion.trim();
          cmbAlmacen.current.value = response.data.idalmacen;
          txtVentas.current.checked = response.data.ventas ? true : false;
          if (!botones.modificar) {
            setBotones({ ...botones, catalogoper: false });
          }
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una ubicacion con este codigo', icono: 'informacion' });
          txtDescripcion.current.value = '';
          cmbAlmacen.current.value = '';
          txtVentas.current.checked = false;
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarUbicacion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistro();

      }
    }
  };

  const onCatalogoUbicacion = (values) => {
    setCatalogoUbicacion(false);
    txtCodUbicacion.current.value = values.idubicacion;
    txtDescripcion.current.value = values.descripcionubicacion;
    cmbAlmacen.current.value = values.idalmacen;
    txtVentas.current.checked = values.ventas ? true : false;
  }

  const onChangeValidar = () => {

    let sigue = true;
    if (!botones.incluir || !botones.modificar) {

      if (txtDescripcion.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción a la ubicacion', icono: 'informacion' });
        txtDescripcion.current.focus()
        sigue = false
      } else if (cmbAlmacen.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar el almacen', icono: 'informacion' });
        cmbAlmacen.current.focus()
        sigue = false
      }
    }

    if (sigue) {

      var ubicacion = [];
      ubicacion.push({
        idubicacion: txtCodUbicacion.current.value === '' ? 0 : txtCodUbicacion.current.value,
        descripcionubicacion: txtDescripcion.current.value.trim(),
        idalmacen: cmbAlmacen.current.value,
        ventas: txtVentas.current.checked ? true : false
      })

      setBody({
        ubicacion: ubicacion
      });


      let msg = '';
      if (!botones.incluir) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (!botones.modificar) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (!botones.eliminar) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
    }
  }

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/ubicacion/actualizar/${ope}`;
    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (ope === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (ope === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (ope === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }
        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro con este rif'

        } 
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    procesarRegistro();
  };

  const blanquear = () => {
    setActivate(false);
    setBody(null);
    setHabilitado(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true
    });
    txtCodUbicacion.current.setAttribute("disabled", true);
    txtCodUbicacion.current.value = '';
    txtDescripcion.current.value = '';
    cmbAlmacen.current.value = '';
    txtVentas.current.checked = false;
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const cerrar = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  };

  const onBotones = (op) => (e) => {

    e.preventDefault();

    if (op === 1) {
      setHabilitado(false);
      setBotones({
        incluir: false,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: true
      });
      txtCodUbicacion.current.setAttribute("disabled", true);
      setTimeout(() => txtDescripcion.current.focus(), 200);

    } else if (op === 2) {
      txtCodUbicacion.current.removeAttribute("disabled");
      setHabilitado(false);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: false,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: false
      });
      txtCodUbicacion.current.focus();

    } else if (op === 3) {
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: false,
        aceptar: false,
        cancelar: false,
        catalogo: false
      });
      txtCodUbicacion.current.removeAttribute("disabled")
      txtCodUbicacion.current.focus();
    } else if (op === 4) {
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: false,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false
      });
      txtCodUbicacion.current.removeAttribute("disabled")
      txtCodUbicacion.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      cancelar();
    }
  }

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  return (
    <div className='w-100 h-100'>
      <div className="row col-md-12 m-0">
        <div className='row col-md-12 m-0'>

          <div className='container px-5'>

            <div className='px-5 py-5 col-md-10 mx-auto'>
              <CartasAlmacen />
              <div className='card px-3 py-3'>
                <div className='border-azul  py-3 rounded'>
                  <div style={{ fontFamily: 'Times New Roman, Times, serif' }}>
                    <div className=" row rounded mx-auto d-flex justify-content-between">

                      <div className="input-group input-group-sm mb-2 col-md-4">
                        <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO DE UBICACION:</label>
                        <input type="text" autoComplete='off' ref={txtCodUbicacion} disabled onKeyUp={validarUbicacion} onBlur={validarUbicacion} name="idubicacion" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        <button disabled={botones.catalogo} onClick={() => setCatalogoUbicacion(true)} type="button" className="btn btn-success"><i className="fas fa-search"></i></button>

                      </div>
                      <div className='col-md-7'></div>
                     
                      <div className="col-md-6 input-group input-group-sm mb-2">
                        <label className="input-group-text" id="inputGroup-sizing-sm">DESCRIPCION:</label>
                        <input type="text" autoComplete='off' disabled={habilitado} ref={txtDescripcion} onChange={onChange} name='descripcionubicacion' className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                      </div>
                      <div className="input-group input-group-sm mb-2 col-md-4">
                        <label className="input-group-text" id="inputGroup-sizing-sm">ALMACEN:</label>
                        <select ref={cmbAlmacen} name="almacen" className="form-select form-select-sm px-0" disabled={habilitado} aria-label=".form-select-sm example" onChange={onChange} >
                          <option value="">--</option>
                          {almacen && almacen.map((item, index) => (
                            <option key={index} value={item.idalmacen}> {item.descripcion} </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-check form-check-inline col-md-2 p-0 m-0">
                        <input ref={txtVentas} disabled={habilitado} className="form-check-input py-1" type="checkbox" id="inlineCheckbox1" />
                        <label className="form-check-label px-1" htmlFor="inlineCheckbox1">VENTAS</label>
                      </div>



                    </div>
                  </div>
                </div>
                <div className='col-md-12 d-flex justify-content-between mt-2'>
                      <div className='col-md-7 d-flex justify-content-start'>
                        <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 btn-primary rounded-pill" style={{ height: '27px' }} title='Incluir Almacen'><i style={{ fontSize: '9px' }} className="fas fa-plus"> Incluir </i> </button>
                        <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 btn-info rounded-pill" style={{ height: '27px' }} title='Consultar Almacen' ><i style={{ fontSize: '9px' }} className="fas fa-eye">Consultar</i> </button>
                        <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 btn-warning rounded-pill" style={{ height: '27px' }} title='Modificar Almacen'><i style={{ fontSize: '9px' }} className="fa fa-edit">Modificar</i> </button>
                        <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 btn-danger rounded-pill" style={{ height: '27px' }} title='Eliminar Almacen'><i style={{ fontSize: '9px' }} className="fa fa-trash">Eliminar</i> </button>

                      </div>

                      <div className='col-md-4 d-flex justify-content-end'>
                      <button disabled={botones.aceptar} onClick={onBotones(5)} ref={btnAcepta} style={{ height: '27px' }} className="mx-2 btn btn-sm rounded-pill btn-success"><i className="fas fa-check-circle" style={{ fontSize: '9px' }}>Aceptar</i></button>
                  <button disabled={botones.cancelar} onClick={onBotones(6)} ref={btnCancela} style={{ height: '27px' }} className="mx-2 btn btn-danger btn-sm rounded-pill"><i className="fas fa-window-close" style={{ fontSize: '9px' }}> Cancelar</i></button>

                      </div>
                                  </div>

              </div>
            </div>
          </div>

        </div>
      </div >
      <CatalogoUbicacion
        show={catalogoUbicacion}
        onHideCancelar={() => setCatalogoUbicacion(false)}
        onHideAceptaCatalogo={onCatalogoUbicacion}
      />

      <Mensaje mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === 'Exito.' ?
            cerrar() :
            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        }
        } />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
    </div>
  );
}
export default TablaAlmacen;


// WEBPACK FOOTER //
// ./src/components/almacen/nuevaTablaUbicacion.js